import { render, staticRenderFns } from "./addImg.vue?vue&type=template&id=3acb7029&scoped=true&"
import script from "./addImg.vue?vue&type=script&lang=js&"
export * from "./addImg.vue?vue&type=script&lang=js&"
import style0 from "./addImg.vue?vue&type=style&index=0&id=3acb7029&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acb7029",
  null
  
)

export default component.exports